import { faSpinner, faUserCircle, faEnvelopeOpen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import * as ConsoleStore from '../../../store/Console';
import { getUsersByRoleName } from '../../../ApiUtils/ApiUtils';
import { UserProfileContext } from '../ConsoleLayout';
import Version from '../../../Version';

type SupportTeamProps = {} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

type SupportTeamState = {
    userList: { role: string; email: string; firstName: string; lastName: string }[];
    isLoading: boolean;
};

class SupportTeam extends React.Component<SupportTeamProps, SupportTeamState> {
    static contextType = UserProfileContext;
    constructor(props: SupportTeamProps) {
        super(props);
        this.state = {
            userList: [],
            isLoading: false,
        };
    }

    componentDidMount() {
        const fetchUsers = async () => {
            try {
                this.setState({ isLoading: true });

                const accountManagerResponse = await getUsersByRoleName(
                    "GDSLINK",
                    `admin_company:${this.context.company}`
                );

                const adminResponse = await getUsersByRoleName(
                    this.context.company,
                    "admin"
                );

                const accountManagers = JSON.parse(accountManagerResponse)
                    .filter((user: any) => user.attributes?.["display_as_account_manager"]?.[0] === "true")
                    .map((user: any) => ({
                        role: "Account Manager",
                        email: user.email ? user.email : user.username,
                        firstName: user.firstName,
                        lastName: user.lastName
                    }));

                const admins = JSON.parse(adminResponse)
                    .filter((user: any) => user.attributes?.["display_as_admin"]?.[0] === "true")
                    .map((user: any) => ({
                        role: "Administrator",
                        email: user.email ? user.email : user.username,
                        firstName: user.firstName,
                        lastName: user.lastName
                    }));

                const combinedUserList = [...accountManagers, ...admins];
                this.setState({
                    userList: combinedUserList,
                    isLoading: false
                });

            } catch (error) {
                this.setState({ isLoading: false });
                console.error("Error fetching user data:", error);
            }
        };

        fetchUsers();
    }

    public render() {
        return (
            <>
                <div className="support-footer">
                    <Col style={{ "position": "absolute" }}>
                        <div>
                            <p style={{ "fontSize": "0.75rem", "margin": "0" }}>Support Team</p>
                        </div>
                        {this.state.isLoading ? (
                            <div className="text-center">
                                <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />
                            </div>
                        ) : (
                            this.state.userList.map((user, index) => (
                                <span key={index} style={{ "fontSize": "0.75rem" }}>
                                    {index > 0 &&
                                        <span className="mr-5">|</span>
                                    }
                                    <span className="mr-5"><FontAwesomeIcon icon={faEnvelopeOpen} size="1x" color="white" swapOpacity={true} /></span>
                                    <span className="mr-5"><a href={`mailto:${user.email}`} style={{ "textDecoration": "none", "color": "white" }}>{user.email}</a></span>
                                    <span className="mr-5"><FontAwesomeIcon icon={faUserCircle} size="1x" color="white" swapOpacity={true} /></span>
                                    <span className="mr-5">{user.firstName} {user.lastName}</span>
                                </span>
                            )))}
                    </Col>
                    <Col style={{ "textAlign": "right", "height": "100%", "padding": "0 15px" }}>
                        <p style={{ "margin": "0", "alignContent": "center", "height": "inherit", "fontSize": "0.75rem" }}>&copy; 2025 GDS Link<br /><span style={{ "fontSize": "0.65rem" }}>v {Version.FullVersion}</span></p>
                    </Col>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupportTeam);
